import styled from '@emotion/styled';

export const PopoverWrapper = styled.span`
    display: inline-block;
`;
